import { appConfig } from '@common-config/app.config';
import type { GatewayOfferResponse } from '@extension/wa-communication-layer/api/api-calls';

/** The page where a Gateway is added (Connections). The offer never builds its own flow. */
export function gatewayOfferUrl(): string {
  return `${appConfig.PRICING_PAGE}/connections`;
}

/** True only for a shown-arm offer from the server. The holdout arm is never rendered. Text comes from i18n keys. */
export function shouldShowGatewayOffer(res: GatewayOfferResponse | null | undefined): res is GatewayOfferResponse {
  return !!res && res.show === true && res.arm === 'shown';
}
